import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Dialog from 'Components/Molecules/Dialog/Dialog';
import Button from 'Components/Atoms/Button/Button';
import OutlineContactSupport from 'Components/Atoms/OutlineIcons/OutlineContactSupport';
import { useGlobalFloating } from 'Components/Organisms/GlobalFloatingProvider/GlobalFloatingProvider';
import { ROUTES } from 'Utils/constants';

const DOCS_URL = 'https://docs.banktrack.com';

export default function DiscontinuedPlanSupportChat({ open, onOpen, onClose }) {
    const { t } = useTranslation('common');
    const { showChat } = useGlobalFloating();
    const navigate = useNavigate();

    const goToSubscriptionSettings = () => {
        onClose();
        navigate(ROUTES.settingsSubscription);
    };

    return (
        <>
            {showChat && (
                <button
                    type="button"
                    aria-label={t('discontinued-plan-support-launcher-label')}
                    onClick={onOpen}
                    className="fixed bottom-5 right-5 z-[var(--z-index-bubble)] flex size-12 cursor-pointer items-center justify-center rounded-full bg-primary text-white shadow-lg transition-transform hover:scale-105 active:scale-95"
                >
                    <OutlineContactSupport size={26} strokeWidth={1.8} />
                </button>
            )}

            <Dialog open={open} onClose={onClose} size="xs" title={t('discontinued-plan-support-title')}>
                <div className="space-y-3 text-pretty text-dark-blue/80">
                    <p>{t('discontinued-plan-support-description')}</p>
                    <p>
                        <Trans
                            t={t}
                            i18nKey="discontinued-plan-support-billing-description"
                            components={[
                                <a
                                    key="support-email"
                                    href="mailto:soporte@banktrack.com"
                                    className="font-medium text-primary underline"
                                />,
                            ]}
                        />
                    </p>
                </div>

                <div className="mt-6 flex justify-end gap-3">
                    <Button onClick={goToSubscriptionSettings}>{t('discontinued-plan-support-subscription-button')}</Button>
                    <Button variant="primary" href={DOCS_URL} target="_blank">
                        {t('discontinued-plan-support-docs-button')}
                    </Button>
                </div>
            </Dialog>
        </>
    );
}

DiscontinuedPlanSupportChat.propTypes = {
    open: PropTypes.bool,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
